module.exports = __webpack_public_path__ + "img/full-img2.7cbd27f2.png";